module.exports = __webpack_public_path__ + "img/yukata.c137876e.jpg";